const MENU_TYPES = {
    DETAIL: "detail",
    VISIBILITY: "visibility",
    COMPARISON: "comparison",
};

const Items = (that) => [
    {
        enabled: true,
        key: MENU_TYPES.DETAIL,
        label: that?.$t("Whatsapp V3 Channel Detail") || "Whatsapp V3 Channel Detail",
        icon: {
            type: "material-icons",
            name: "info",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.VISIBILITY,
        label: that?.$t("multi_whatsapp_api.visibility") || "Visibility",
        icon: {
            type: "material-icons",
            name: "visibility",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.COMPARISON,
        label: "WhatsApp Çözümleri Karşılaştırması",
        icon: {
            type: "material-icons",
            name: "compare",
        },
    },
];

export default {
    MENU_TYPES,
    Items,
};
